<template>
	<VerifyEmailDialog
		:verification-requested="verificationRequested"
		@resend="onResendEmailVerification"
	/>
</template>

<script>
import { foundation } from "@teaming/slice-engine";
import VerifyEmailDialog from "./VerifyEmailDialog";

export default {
	name: "VerifyEmailDialogHOC",
	components: {
		VerifyEmailDialog,
	},
	inject: [ "userProfile", ],
	data() {
		return {
			verificationRequested: false,
		};
	},
	methods: {
		onResendEmailVerification() {
			// lazy man's debounce :)
			if ( this.verificationRequested ) {
				return;
			}
			foundation().ioUser.requestEmailVerification();
			this.verificationRequested = true;
			setTimeout( () => {
				this.verificationRequested = false;
				// eslint-disable-next-line no-magic-numbers
			}, 5000 );
		},
	},
};
</script>

<style lang="scss" scoped></style>
